module.exports = __webpack_public_path__ + "sgby/img/zhouyu-pic.734ba06.png";